module.exports = "<ng2common-site-header class=\"noPrint\"></ng2common-site-header>\n<div class=\"full height\">\n    <app-mainmenu class=\"noPrint\"></app-mainmenu>\n    <div class=\"content\">\n       <router-outlet></router-outlet>\n    </div>\n    <ng2common-site-footer [jurisdiction]=\"'NSW'\" class=\"noPrint\"></ng2common-site-footer>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/app.component.html
// module id = ./client/app/app.component.html
// module chunks = main